export function pickDefaultPlantId(plants) {
  if (!plants?.length) {
    return '';
  }
  if (plants.length === 1) {
    return String(plants[0].value);
  }
  return '';
}

export function getInitialDesignMixFormState() {
  return {
    recipe_code: '',
    cem1: 0,
    cem2: 0,
    cem3: 0,
    cem4: 0,
    cem5: 0,
    agg1: 0,
    agg2: 0,
    agg3: 0,
    agg4: 0,
    agg5: 0,
    water1: 0,
    water2: 0,
    adm1: 0,
    adm2: 0,
    others: 0,
    plant_id: '',
    work_schedule_id: '',
    total_cem: 0,
    water_cem: 0,
    density: 0,
  };
}

export function buildWorkScheduleOptionLabel(workSchedule) {
  const salesOrder = workSchedule?.sales_order_detail?.sales_order;
  const product = workSchedule?.sales_order_detail?.product;
  return `${workSchedule.schedule_no}-${salesOrder?.prefix || ''}${salesOrder?.order_no || ''}(${product?.name || ''})`;
}

export function buildWorkScheduleDisplayLabel(workSchedule) {
  if (!workSchedule?.schedule_no) {
    return '';
  }
  return buildWorkScheduleOptionLabel(workSchedule);
}

export function mapAllowedPlants(plantList) {
  return (plantList?.plant_list || [])
    .filter((plant) => plant.status)
    .map((plant) => ({
      value: plant.id,
      label: plant.plant_alias,
    }));
}

export function isAdmixInKgs(plantConfig) {
  const value = plantConfig?.is_admix_in_kgs;
  return !(value === false || value === 0 || value === '0' || value === 'false');
}

function toInt(value) {
  const parsed = parseInt(value, 10);
  return Number.isFinite(parsed) ? parsed : 0;
}

function toFloat(value) {
  const parsed = parseFloat(value);
  return Number.isFinite(parsed) ? parsed : 0;
}

export function buildDesignMixSaveFields(inputs, plantConfig) {
  const cem1 = toInt(inputs.cem1);
  const cem2 = toInt(inputs.cem2);
  const cem3 = toInt(inputs.cem3);
  const cem4 = toInt(inputs.cem4);
  const cem5 = toInt(inputs.cem5);
  const agg1 = toInt(inputs.agg1);
  const agg2 = toInt(inputs.agg2);
  const agg3 = toInt(inputs.agg3);
  const agg4 = toInt(inputs.agg4);
  const agg5 = toInt(inputs.agg5);
  const water1 = toInt(inputs.water1);
  const water2 = toInt(inputs.water2);
  const adm1 = toFloat(inputs.adm1);
  const adm2 = toFloat(inputs.adm2);
  const others = toInt(inputs.others);
  const adm1Kg = isAdmixInKgs(plantConfig) ? adm1 : adm1 / 1000;
  const adm2Kg = isAdmixInKgs(plantConfig) ? adm2 : adm2 / 1000;
  const totalCem = cem1 + cem2 + cem3 + cem4 + cem5;
  const totalWater = water1 + water2;
  return {
    cem1,
    cem2,
    cem3,
    cem4,
    cem5,
    agg1,
    agg2,
    agg3,
    agg4,
    agg5,
    water1,
    water2,
    adm1,
    adm2,
    others,
    total_cem: totalCem,
    water_cem: totalCem > 0 ? Number((totalWater / totalCem).toFixed(2)) : 0,
    density: Number((
      cem1 + cem2 + cem3 + cem4 + cem5
      + agg1 + agg2 + agg3 + agg4 + agg5
      + water1 + water2 + adm1Kg + adm2Kg + others
    ).toFixed(2)),
  };
}

export function getDesignMixSaveWarning(inputs, plantConfig) {
  const adm1 = parseFloat(inputs.adm1) || 0;
  const adm2 = parseFloat(inputs.adm2) || 0;
  const other3 = plantConfig?.other_3 || 'Other 3';
  const other4 = plantConfig?.other_4 || 'Other 4';

  if (isAdmixInKgs(plantConfig)) {
    if (adm1 < 0 || adm1 > 5) {
      return `${other3} must be between 0 and 5 kg/m³. Current value is ${adm1}.`;
    }
    if (adm2 < 0 || adm2 > 5) {
      return `${other4} must be between 0 and 5 kg/m³. Current value is ${adm2}.`;
    }
  } else {
    if (adm1 > 0 && adm1 < 100) {
      return `${other3} must be 0 or at least 100 g/m³. Current value is ${adm1}.`;
    }
    if (adm1 > 5000) {
      return `${other3} must not be greater than 5000 g/m³. Current value is ${adm1}.`;
    }
    if (adm2 > 0 && adm2 < 100) {
      return `${other4} must be 0 or at least 100 g/m³. Current value is ${adm2}.`;
    }
    if (adm2 > 5000) {
      return `${other4} must not be greater than 5000 g/m³. Current value is ${adm2}.`;
    }
  }

  const totals = buildDesignMixSaveFields(inputs, plantConfig);
  if (totals.density < 2200 || totals.density > 3000) {
    return `Density must be between 2200 and 3000. Current value is ${totals.density}.`;
  }
  if (totals.water_cem < 0.1 || totals.water_cem > 1) {
    return `Water-cement ratio must be between 0.10 and 1. Current value is ${totals.water_cem}.`;
  }
  return '';
}
